module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_hat-8e4d8e2d32f5fe55005915d80385fb6c.svg";